import React from 'react';

import { useNavigate, Link } from "react-router-dom";

import CaseItem from '../CaseItem/CaseItem';
import './CasesList.css';


export default function CasesList({ 
    cases,
    onSelectedCase
}) {
  if (cases.length === 0) {
    return <h2 className='cases-list__fallback'>Found no cases.</h2>;
  }

  console.log ( 'CasesList: cases =', cases); 

  var res = [];
             
    var x = 0;
      for (let i in cases) {
        x += 1;
        res.push(cases[i]);
      }
      
      console.log('CasesList: length: ', x );  


  //var casesJSON = JSON.parse (cases);
  console.log ( 'res=', res); 
  return (
    <ul className='cases-list'>
      {res.map((rescase) => (
        <CaseItem
          key={rescase.case.case_controlnum}
          control_num={rescase.case.case_controlnum}
          patient_name={rescase.case.case_patientname}
          birth_date={rescase.case.case_patbirthdate}
        />
      ))}
    </ul>
  );
};

